// Define the type for the announcement update event
interface AnnouncementUpdateDetail {
    show: boolean
}

export default class Hero extends HTMLElement {
    private section: HTMLElement | null = null
    private isFirstSection: boolean = false
    private announcementBarHeight: number = 0
    private defaultHeight: string = ''
    private boundHandleAnnouncementUpdate: (event: Event) => void

    constructor() {
        super()

        console.log('Hero constructor')

        this.section = this.querySelector('[data-section]')

        console.log('Hero section', this.section)

        this.boundHandleAnnouncementUpdate = this.handleAnnouncementUpdate.bind(this)

        // Check if this is the first section on the page
        if (this.section) {
            // Store original height values
            const computedStyle = window.getComputedStyle(this.section)
            this.defaultHeight = this.section.style.height || computedStyle.height

            console.log('Hero default height', this.defaultHeight)

            // Check if this is the first section by measuring its offset from the top
            const sectionRect = this.section.getBoundingClientRect()
            const headerHeight = document.querySelector('shop-header')?.getBoundingClientRect().height || 0

            console.log('Hero sectionRect', sectionRect)
            console.log('Hero header height', headerHeight)

            // If the section is at the top of the page (accounting for the header)
            this.isFirstSection = sectionRect.top <= 45 // Adding a small buffer

            console.log('Hero isFirstSection', this.isFirstSection)

            if (this.isFirstSection) {
                console.log('Hero is the first section, will adjust for announcement bar')

                // Listen for announcement bar updates
                window.addEventListener('announcement:update', this.boundHandleAnnouncementUpdate)

                // Get initial announcement bar state
                const announcementBar = document.querySelector('shop-announcement-bar')
                if (announcementBar) {
                    const container = announcementBar.querySelector('[data-container]')
                    if (container && !container.classList.contains('hidden')) {
                        this.announcementBarHeight = container.getBoundingClientRect().height
                        this.adjustHeight(true)
                    }
                }
            }
        }
    }

    private handleAnnouncementUpdate(event: Event): void {
        // Cast the event to CustomEvent with our detail type
        const customEvent = event as CustomEvent<AnnouncementUpdateDetail>
        const show = customEvent.detail?.show || false

        // Get the height of the announcement bar
        if (show) {
            const announcementBar = document.querySelector('shop-announcement-bar')
            if (announcementBar) {
                const container = announcementBar.querySelector('[data-container]')
                if (container) {
                    this.announcementBarHeight = container.getBoundingClientRect().height
                }
            }
        }

        this.adjustHeight(show)
    }

    private adjustHeight(showAnnouncementBar: boolean): void {
        if (!this.section || !this.isFirstSection) return

        if (showAnnouncementBar && this.announcementBarHeight > 0) {
            // Adjust the height by subtracting the announcement bar height
            const newCalcHeight = `calc(var(--vh, 1vh) * 100 - ${this.announcementBarHeight}px)`

            // Apply the new height
            this.section.style.height = newCalcHeight

            // For larger screens, we keep the lg:h-screen but adjust the min-height
            const newMinHeight = `${600 - this.announcementBarHeight}px`
            this.section.style.setProperty('--hero-min-height', newMinHeight)

            // Add a CSS class to handle the lg breakpoint height
            this.section.classList.add('announcement-bar-active')
        } else {
            // Reset to original height
            this.section.style.height = ''
            this.section.style.removeProperty('--hero-min-height')
            this.section.classList.remove('announcement-bar-active')
        }
    }

    connectedCallback() {
        // Add a style element for the lg breakpoint adjustment
        if (this.isFirstSection) {
            const styleEl = document.createElement('style')
            styleEl.textContent = `
                .announcement-bar-active {
                    height: calc(var(--vh, 1vh) * 100 - ${this.announcementBarHeight}px);
                }
                @media (min-width: 1024px) {
                    .announcement-bar-active {
                        height: calc(100vh - ${this.announcementBarHeight}px);
                        min-height: var(--hero-min-height, 600px);
                    }
                }
            `
            document.head.appendChild(styleEl)
        }
    }

    disconnectedCallback() {
        if (this.isFirstSection) {
            window.removeEventListener('announcement:update', this.boundHandleAnnouncementUpdate)
        }
    }
}

customElements.define('shop-hero', Hero)
